/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ResourceInputs */

const en_resource = /** @type {(inputs: ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource`)
};

const es_resource = /** @type {(inputs: ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurso`)
};

const fr_resource = /** @type {(inputs: ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource`)
};

const de_resource = /** @type {(inputs: ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource`)
};

const id_resource = /** @type {(inputs: ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber Daya`)
};

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const ja_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const zh_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const ar_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const it_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const ru_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const pt_resource = en_resource;

/** @type {(inputs: ResourceInputs) => LocalizedString} */
const ko_resource = en_resource;

/**
* | output |
* | --- |
* | "Resource" |
*
* @param {ResourceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const resource = /** @type {((inputs?: ResourceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ResourceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resource(inputs)
	if (locale === "es") return es_resource(inputs)
	if (locale === "fr") return fr_resource(inputs)
	if (locale === "de") return de_resource(inputs)
	if (locale === "ja") return ja_resource(inputs)
	if (locale === "zh") return zh_resource(inputs)
	if (locale === "ar") return ar_resource(inputs)
	if (locale === "id") return id_resource(inputs)
	if (locale === "it") return it_resource(inputs)
	if (locale === "ru") return ru_resource(inputs)
	if (locale === "pt") return pt_resource(inputs)
	return ko_resource(inputs)
});